<template>
  <v-dialog
    v-model="visible"
    max-width="400px"
    persistent
  >
    <v-card class="pa-3">
      <h2>¿Confirma la reserva del turno?</h2>
      <!--       <div class="mb-1 text-xs-left">
        <div>Profesional: <b>{{ appointment.profesional }}</b></div>
        <div>Fecha: <b>{{ fecha }}</b></div>
        <div>Cobertura: <b>{{ getSelectionParams.selectedCobertura.nombre }}</b></div>
        <div>Prestación: <b>{{ getSelectionParams.selectedPrestacion.nombre }}</b></div>
      </div> -->
      <v-avatar
        class="right"
        size="130"
      >
        <img :src="appointment.foto">
      </v-avatar>
      <div class="mb-1 mt-1 text-xs-left">
        <div class="mb-1 mt-1">
          Profesional <br> <b>{{ appointment.profesional }}</b>
        </div>
        <div class="mb-1 mt-1">
          Fecha y Hora<br> <b>{{ fecha }}</b>
        </div>
        <div class="mb-1 mt-1">
          Cobertura <br> <b>{{ getSelectionParams.selectedCobertura.nombre }}</b>
        </div>
        <div class="mb-1 mt-1">
          Prestación <br> <b>{{ getSelectionParams.selectedPrestacion.nombre }}</b>
        </div>
      </div>
      <v-divider />
      <div
        v-if="message"
        class="mt-1 mb-1 text-xs-left"
      >
        <u>Información Importante sobre el Turno</u>
        <div><b>{{ message }}</b></div>
      </div>
      <!-- <v-divider />
      <div class="mt-1 mb-1 text-xs-left">
        <u>Datos de Contacto</u>
        <div>
          Correo Electrónico:
          <b v-if="userForm.email"> {{ userForm.email }}</b>
          <b v-else> sin informar</b>
        </div>
        <div>
          Celular:
          <b v-if="userForm.phone"> {{ userForm.phone }}</b>
          <b v-else> sin informar</b>
        </div>
        <div>Actualice sus datos de Contacto en la opción <b>Mis Datos</b></div>
      </div> -->
      <div v-if="company.notaTurno">
        <v-divider />
        <v-form v-model="valid">
          <v-textarea
            v-model="note"
            label="Nota Paciente"
            :counter="max"
            :disabled="loading"
            :rows="4"
            class="primary--text"
            maxlength="200"
          />
        </v-form>
      </div>
      <div class="text-xs-right mt-4">
        <v-btn
          class="error--text"
          :disabled="loading"
          outline
          @click="closeModal"
        >
          Cancelar
        </v-btn>
        <v-btn
          class="primary"
          :loading="loading"
          :disabled="loading"
          @click="acceptAppointment"
        >
          Confirmar
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { reservarTurno } from '../../api/appointmentsEndpoints'
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'AppointmentAcceptModal',
  filters: {
    fecha (value) {
      return moment(value).format('DD-MM-YYYY HH:MM')
    }
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    appointment: {
      type: Object,
      required: true
    },
    message: {
      default: '',
      type: String,
      required: false
    }
  },
  data () {
    return {
      note: '',
      max: 200,
      valid: false,
      loading: false,
      userForm: {
        email: null,
        phone: null
      }
    }
  },
  computed: {
    ...mapState(['company']),
    ...mapGetters(['user', 'getSelectionParams']),
    fecha () {
      moment.locale('es')
      const hora = this.appointment.hora
      const fecha = this.appointment.fecha
      let parsedFecha = ''
      if (fecha) {
        parsedFecha = `${fecha.substring(0, 4)}-${fecha.substring(4, 6)}-${fecha.substring(6, 8)}`
      }
      return `${moment(parsedFecha).format('dddd').toUpperCase()} ${moment(parsedFecha).format('DD-MM-YYYY')} a las ${hora}`
    }
  },
  async mounted () {
    this.userForm = { ...this.user }
  },
  methods: {
    async acceptAppointment () {
      const turno = {
        pacienteId: this.user.id,
        obraSocial: this.getSelectionParams.selectedCobertura.obraSocial,
        plan: this.getSelectionParams.selectedCobertura.plan,
        turno: this.appointment.turno,
        nota: this.note,
        prestacion: this.getSelectionParams.selectedPrestacion.prestacion
      }
      this.loading = true
      const acceptedAppointment = await reservarTurno(turno)
      this.closeModal()
      this.loading = false
      if (acceptedAppointment.respuesta === 'ERROR') {
        this.$createAlert({
          message: acceptedAppointment.mensaje,
          type: 'error',
          duration: 5000
        })
      } else {
        this.$createAlert({
          message: 'Turno reservado',
          type: 'success',
          duration: 3000
        })
        this.$router.push('/turnos')
      }
    },
    closeModal () {
      this.$emit('accepted')
    }
  }
}
</script>

<style scoped>

</style>
